import React, { useEffect, useRef, useState } from "react";
import { apiGetFileDownload, apiPost } from "../../../../services/service";
import {
  GET_FILE_DOWNLOAD,
  POST_PROFILE_PAGE_LOAD,
} from "../../../../services";
import { toast } from "react-toastify";
import { Button, Table } from "@veneer/core";
import Loader from "../../shared-components/loader/loader";
import { Trans, useTranslation } from "react-i18next";
declare global {
  interface Navigator {
    msSaveBlob?: (blob: Blob, filename: string) => boolean;
    webkitSaveBlob?: (blob: Blob, filename: string) => boolean;
    mozSaveBlob?: (blob: Blob, filename: string) => boolean;
    saveBlob?: (blob: Blob, filename: string) => boolean;
  }
}

interface TabTableProps {
  childtabid: string;
  refreshTrigger?: boolean;
}

const TabTable: React.FC<TabTableProps> = ({ childtabid }) => {
  const { t } = useTranslation();
  const [progress, setProgress] = useState<boolean>(false);
  const [tableRowData, setTableRowData] = useState<any[]>([]);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const columns = [
    { id: "File", label: t("HPI.Filename", { defaultvalue: "File Name" }) },
    {
      id: "DateCreated",
      label: t("HPI.Lastmodifiedon", { defaultvalue: "Last Modified On" }),
    },
    {
      id: "FileUri",
      label: t("HPI.Profilepage.generalinstruction.Download", {
        defaultvalue: "Download",
      }),
    },
  ];
  useEffect(() => {
    if (childtabid) {
      fetchTableData(childtabid);
      if (intervalRef.current) clearInterval(intervalRef.current);
      intervalRef.current = setInterval(() => {
        fetchTableData(childtabid);
      }, 25000);
    }
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [childtabid]);

  const fetchTableData = async (childtabid: string) => {
    if (!childtabid) return;
    setProgress(true);

    const payload = {
      tabid: "bulkupload",
      childtabid,
      
      
    };

    try {
      const res = await apiPost(POST_PROFILE_PAGE_LOAD, payload);
      if (res.data) {
        const bulkData = JSON.parse(res.data.BulkData);
        
        const rows = bulkData.map((item: any) => ({
          File: item.File,
          DateCreated: item.DateCreated,
          FileUri: renderDownloadLink(`${item.ContainerName};${item.File}`, item.File,item.IsDownloadable),
        }));
        setTableRowData(rows);
      } else {
        toast.error(res.Message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setProgress(false);
    }
  };

  // Download file
  const downloadFile = async (FileUri: string, fileName: string) => {
    try {
      const response = await apiGetFileDownload(
        `${GET_FILE_DOWNLOAD}/${FileUri}`
      );

      if (response.status === 200) {
        const contentType =
          response.headers.get("Content-Type") || "application/octet-stream";
        const filename = fileName;
        const blob = new Blob([response.data], { type: contentType });
        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(blob, filename);
        } else {
          const downloadUrl = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = downloadUrl;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(downloadUrl);
        }
      }
    } catch (error) {
      console.error("Error during file download:", error);
      toast.error("File download failed. Please try again.");
    }
  };

  const renderDownloadLink = (FileUri: string, filename: string, download: string) => (
    <Button
      onClick={download=== "True" ? () => downloadFile(FileUri.replace(".csv", ""), filename) : undefined}
      disabled={download=== "True"?false:true} 
      className="link"
    >
      {t("HPI.Profilepage.generalinstruction.Download", {
        defaultvalue: "Download",
      })}
    </Button>
  );

  return (
    <>
      {progress && (
        <div className="loader-overlay">
          <div className="loader-css">
            <Loader />
          </div>
        </div>
      )}
      <Table columns={columns} preferences={{
        width: [
          {
            columnId: 'File',
            width: 500
          },] }} data={tableRowData} />
    </>
  );
};

export default TabTable;
